export default "__VITE_ASSET__6Fnza7yZ__"